import './App.css';
import Poc from './pages/Poc';



function App() {
  return (
    <div className="App">
        <Poc />
    </div>
  );
}

export default App;

// event from pwa
// {event_type : "polling:start", data : {frequency : 1000}
// {event_type : "polling:update", data : {frequency : 1000}
// {event_type : "polling:stop", data:{}}
// {event_type : "skymon:input", data : {value:  1000, delay : 1000}

// event from ptlu
// {event_type : "skymon:output", data : {value:  1000, skymon_timestamp: 946681200, ptlu_timestamp: 946681200}

